import { Grid, Skeleton } from "@mui/material";

const arr = [1, 2, 3, 4, 5, 6];

export const SkeletonBlogList = () => {
  return (
    <>
      {arr.map((item, i) => {
        return (
          <Grid container spacing={5} alignItems={"center"} key={i}>
            <Grid item xs={12} sm={12} md={6} lg={5}>
              <Skeleton variant="rectangular" width="100%" height={200} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={7}>
              <Skeleton
                variant="rectangular"
                width="30%"
                height={30}
                sx={{ margin: "20px 0px" }}
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={30}
                sx={{ margin: "20px 0px" }}
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={30}
                sx={{ margin: "20px 0px" }}
              />
              <Skeleton
                variant="rectangular"
                width="90%"
                height={30}
                sx={{ margin: "20px 0px" }}
              />
            </Grid>
          </Grid>
        );
      })}
    </>
  );
};

export default SkeletonBlogList;
